<section
	*qeHideProd
	role="alert"
	aria-live="polite"
	class="environment-warning"
>
	<div class="environment-warning__message">
		<epi-icon
			use="error"
			color="custom:#ffffff"
			:size="20"
			class="environment-warning__icon"
		></epi-icon>IMPORTANT: QuoteEngine is running in the {{ environmentId }} environment!
	</div>
	<div class="environment-warning__user-id">
		User Id: <span class="environment-warning__copy-link" (click)="copyUserIdToClipboard()">{{userId || 'n/a'}}</span>
		<button 
			(click)="openStatsigFlagsDialog()" 
			title="View Statsig Flags"
			class="statsig-flags-button"
		>
			⚙️
		</button>
		<span
			class="environment-warning__sync-status"
			[ngClass]="syncStatusClassName"
			[title]="syncStatusTitle"
		>
			<span class="environment-warning__sync-icon" *ngIf="isSyncConnected">
				🟢
			</span>
			<span class="environment-warning__sync-icon" *ngIf="!isSyncConnected">
				⚪
			</span>
			<span class="environment-warning__sync-mode">{{ syncModeLabel }}</span>
			<span class="environment-warning__sync-count">{{ connectedTabCount$ | async }}</span>
		</span>
	</div>
	<div class="environment-warning__actions">
		<button (click)="generateQuote('Dog')" id="generate-dog-quote-button">Generate Quote - Dog</button>
		<button (click)="generateQuote('Cat')" id="generate-cat-quote-button">Generate Quote - Cat</button>
		<button (click)="resetSession()" id="reset-session-button">Reset Session and restart</button>
	</div>
</section>
